  import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import CreditAccountCard from './components/CreditAccountCard'
import PrizeAccountCard from './components/PrizeAccountCard'
import UsageBreakdownCard from './components/UsageBreakdownCard'
import OverviewList from './components/OverviewList'
import CommercialTermsCard from './components/CommercialTermsCard'
import BillingSummaryRow from './components/BillingSummaryRow'
import RecentTransactionsCard from './components/RecentTransactionsCard'
import PrizeScheduleModal from './components/PrizeScheduleModal'
import RatesModal from './components/RatesModal'
import TopUpCreditModal from './components/TopUpCreditModal'
import FundPrizeAccountModal from './components/FundPrizeAccountModal'

export default withTranslation()(function Billing({ t }) {
  const [showPrizeSchedule, setShowPrizeSchedule] = useState(false)
  const [showRates, setShowRates] = useState(false)
  const [showTopUp, setShowTopUp] = useState(false)
  const [showFundPrize, setShowFundPrize] = useState(false)

  const creditOverviewItems = [
    { label: t('billing.credit_overview.available_balance'), value: 'GHS 0.00', valueClassName: 'text-success' },
    { label: t('billing.credit_overview.reserved_amount'), value: 'GHS 0.00' },
    { label: t('billing.credit_overview.daily_average_usage'), value: 'GHS 0.00' },
    { label: t('billing.credit_overview.estimated_days_remaining'), value: t('billing.credit_overview.days', { count: 0 }) },
    { label: t('billing.credit_overview.auto_top_up'), value: t('billing.credit_overview.disabled') }
  ]

  const prizeOverviewItems = [
    { label: t('billing.prize_overview.secured_prize_balance'), value: 'GHS 10,250.00', valueClassName: 'text-success' },
    { label: t('billing.prize_overview.weekly_prize_reserve'), value: 'GHS 0.00' },
    { label: t('billing.prize_overview.monthly_prize_reserve'), value: 'GHS 0.00' },
    { label: t('billing.prize_overview.upcoming_prize_obligations'), value: 'GHS 0.00' },
    { label: t('billing.prize_overview.next_payout_date'), value: '--' }
  ]

  return (
    <section className="w-full mx-auto pb-10">
      <h1 className="text-2xl font-semibold text-dark-blue mb-6">{t('billing.title')}</h1>

      <div className="flex flex-col gap-6">
        <div className="flex flex-col md:flex-row gap-6">
          <CreditAccountCard onTopUp={() => setShowTopUp(true)} />
          <PrizeAccountCard onFund={() => setShowFundPrize(true)} />
        </div>

        <div className="flex flex-col md:flex-row gap-6 items-stretch">
          <UsageBreakdownCard />

          <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4">
            <p className="text-base font-semibold text-dark-blue mb-2">{t('billing.credit_overview.title')}</p>
            <OverviewList items={creditOverviewItems} />
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-6 items-stretch">
          <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4">
            <div className="flex items-center justify-between gap-4 mb-2">
              <p className="text-base font-semibold text-dark-blue">{t('billing.prize_overview.title')}</p>

              <button
                type="button"
                onClick={() => setShowPrizeSchedule(true)}
                className="flex items-center gap-1.5 text-primary text-sm font-semibold whitespace-nowrap"
              >
                {t('billing.prize_overview.view_schedule')} <span aria-hidden>→</span>
              </button>
            </div>

            <OverviewList items={prizeOverviewItems} rowClassName="py-3.5" />
          </div>

          <CommercialTermsCard onViewAll={() => setShowRates(true)} />
        </div>

        <BillingSummaryRow />

        <RecentTransactionsCard />
      </div>

      {showPrizeSchedule && <PrizeScheduleModal onClose={() => setShowPrizeSchedule(false)} />}
      {showRates && <RatesModal onClose={() => setShowRates(false)} />}
      {showTopUp && <TopUpCreditModal handleClick={() => setShowTopUp(false)} />}
      {showFundPrize && <FundPrizeAccountModal handleClick={() => setShowFundPrize(false)} />}
    </section>
  )
})
